import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabTestApi } from '../api/labtest.api';
import { switchMap, map } from 'rxjs/operators';

import { LabWorkOrderData, LabWorkOrder } from '../../../interfaces/lab/lab-work-order' ;
import { LabWorkOrderApi } from '../api/lab-work-order.api';
@Injectable()
export class LabWorkOrderService extends LabWorkOrderData {

    constructor(private api: LabWorkOrderApi) {
      super();
    }


    list(url: string): Observable<LabWorkOrder[]> {
      return this.api.list(url);
    }

    labWorkOrderQueue(url: string): Observable<any[]> {
      return this.api.labWorkOrderQueue(url);
    }

    getById(url:string): Observable<LabWorkOrder>{
        return this.api.getById(url);
    }

    create(url: string, data:LabWorkOrder): Observable<LabWorkOrder[]> {
      return this.api.add(url,data);
    }
    createLabMaster(url: string, data:any): Observable<any> {
      return this.api.add(url,data);
    }
    updateLabMaster(url: string, data:any): Observable<any> {
      return this.api.updateLabMaster(url,data);
    }

    update(url: string, data:LabWorkOrder): Observable<LabWorkOrder[]> {
      return this.api.update(url,data);
    }



    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }

    searchList(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }

    sendMessage(url: string,data: any): Observable<any> {
      return this.api.sendMessage(url,data);
    }
     //SendMsg
     sendgreetingsMessage(url: string,data: any): Observable<any> {
      return this.api.sendgreetingsMessage(url,data);
    }
    send_email(url: string, data:any): Observable<any> {
      return this.api.send_emaild(url,data);
    }
    createHomeCollection(url: string, data:any): Observable<any> {
      return this.api.addHomeCollection(url,data);
    }
    listCollectionMode(url: string): Observable<any> {
      return this.api.listCollectionMode(url);
    }
    updateWorkOrder(url: string): Observable<any> {
      return this.api.updateWorkOrder(url);
    }
    BackDatedWorkOrderDto(url: string, data:any): Observable<any> {
      return this.api.BackDatedWorkOrderDto(url,data);
    }
  }
